const DEFAULT_EVENT_AVAILABILITY = {
  showAfterStart: true,
  showAfterStartMinutes: 10,
  allowRegistrationAfterStart: false
}

function normalizeBoolean (value, fallback) {
  if (value == null) return fallback
  if (typeof value === 'string') {
    if (value === 'true' || value === '1') return true
    if (value === 'false' || value === '0' || value === '') return false
  }
  return Boolean(value)
}

function normalizeMinutes (value) {
  const parsedValue = Number(value)
  return Number.isInteger(parsedValue) && parsedValue > 0
    ? parsedValue
    : DEFAULT_EVENT_AVAILABILITY.showAfterStartMinutes
}

function toTimestamp (value) {
  const timestamp = new Date(value).getTime()
  return Number.isNaN(timestamp) ? null : timestamp
}

export function getEventAvailability (event, now = Date.now()) {
  const startTimestamp = toTimestamp(event && event.startDate)

  if (!startTimestamp) {
    return {
      isLive: false,
      isVisibleInFeed: false,
      registrationOpen: true,
      participationOpen: false
    }
  }

  const showAfterStart = normalizeBoolean(
    event.showAfterStart,
    DEFAULT_EVENT_AVAILABILITY.showAfterStart
  )
  const showAfterStartMinutes = normalizeMinutes(event.showAfterStartMinutes)
  const allowRegistrationAfterStart = normalizeBoolean(
    event.allowRegistrationAfterStart,
    DEFAULT_EVENT_AVAILABILITY.allowRegistrationAfterStart
  )
  const endTimestamp = toTimestamp(event.endDate)
  const postStartVisibleUntil = showAfterStart
    ? startTimestamp + (showAfterStartMinutes * 60 * 1000)
    : null
  const hasStarted = now >= startTimestamp
  const isBeforeStart = !hasStarted
  const isWithinPostStartWindow = Boolean(
    postStartVisibleUntil &&
    hasStarted &&
    now < postStartVisibleUntil
  )
  const hasUsableEndDate = endTimestamp && endTimestamp > startTimestamp
  const isLive = hasStarted && (
    hasUsableEndDate
      ? now < endTimestamp
      : isWithinPostStartWindow
  )

  return {
    isLive,
    isVisibleInFeed: isBeforeStart || isWithinPostStartWindow,
    registrationOpen: isBeforeStart || (
      allowRegistrationAfterStart &&
      isWithinPostStartWindow
    ),
    participationOpen: now >= startTimestamp - (30 * 60 * 1000) && (
      isBeforeStart ||
      isWithinPostStartWindow
    )
  }
}
